import { useState, useEffect, useRef, createContext, useContext, useCallback } from "react";

// ── Spinner keyframe ──────────────────────────────────────────────────────────
(() => {
  if (document.getElementById("igo-spin-style")) return;
  const s = document.createElement("style");
  s.id = "igo-spin-style";
  s.textContent = `@keyframes igo-spin { to { transform: rotate(360deg); } }`;
  document.head.appendChild(s);
})();

// ── Icons ─────────────────────────────────────────────────────────────────────
export const IC = {
  car:    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M5 17H3v-5l2.5-5h13l2.5 5v5h-2"/><circle cx="7.5" cy="17.5" r="1.5"/><circle cx="16.5" cy="17.5" r="1.5"/><path d="M5 12h14"/></svg>,
  search: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>,
  chat:   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>,
  bell:   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>,
  user:   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>,
  back:   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6"/></svg>,
  plus:   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 5v14M5 12h14"/></svg>,
  star:   <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>,
  check:  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6L9 17l-5-5"/></svg>,
  x:      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6L6 18M6 6l12 12"/></svg>,
  send:   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>,
  seat:   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M4 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6H4V5z"/><path d="M2 11h20v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-2z"/><path d="M6 19v2M18 19v2"/></svg>,
  logout: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>,
  clock:  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>,
  pin:    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>,
  mail:   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>,
};

// ── UI Components ─────────────────────────────────────────────────────────────
export const GRAD_PAIRS = [
  ["#667eea","#764ba2"],["#f093fb","#f5576c"],["#4facfe","#00f2fe"],
  ["#43e97b","#38f9d7"],["#fa709a","#fee140"],["#a18cd1","#fbc2eb"],
];

// ── Profile Sheet Context ────────────────────────────────────────────────────
const ProfileSheetCtx = createContext(null);
export const useProfileSheet = () => useContext(ProfileSheetCtx);
export const ProfileSheetProvider = ({ children }) => {
  const [profileUserId, setProfileUserId] = useState(null);
  const open = useCallback((userId) => { if (userId) setProfileUserId(userId); }, []);
  const close = useCallback(() => setProfileUserId(null), []);
  return (
    <ProfileSheetCtx.Provider value={{ profileUserId, open, close }}>
      {children}
    </ProfileSheetCtx.Provider>
  );
};

export const Avatar = ({ user, size = 36, tappable = true }) => {
  const profileSheet = useProfileSheet();
  const idx = (user?.id || "x").charCodeAt((user?.id || "x").length - 1) % GRAD_PAIRS.length;
  const [c1, c2] = GRAD_PAIRS[idx];
  const isPhoto = user?.avatar?.startsWith?.("http");
  const initials = (user?.name || "?").slice(0, 2).toUpperCase();
  const [imgFailed, setImgFailed] = useState(false);
  const canTap = tappable && user?.id && profileSheet;
  const handleClick = (e) => {
    if (!canTap) return;
    e.stopPropagation();
    profileSheet.open(user.id);
  };
  return (
    <div
      onClick={handleClick}
      style={{ width: size, height: size, borderRadius: "50%", background: `linear-gradient(135deg,${c1},${c2})`, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "Syne", fontWeight: 800, fontSize: size * 0.36, flexShrink: 0, boxShadow: `0 2px 8px ${c1}55`, overflow: "hidden", cursor: canTap ? "pointer" : "default", transition: "transform .15s, box-shadow .15s" }}
      onMouseEnter={e => { if (canTap) { e.currentTarget.style.transform = "scale(1.08)"; e.currentTarget.style.boxShadow = `0 2px 8px ${c1}55, 0 0 0 3px rgba(43,91,224,0.15)`; } }}
      onMouseLeave={e => { if (canTap) { e.currentTarget.style.transform = "scale(1)"; e.currentTarget.style.boxShadow = `0 2px 8px ${c1}55`; } }}
    >
      {isPhoto && !imgFailed
        ? <img src={user.avatar} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} onError={() => setImgFailed(true)}/>
        : <span style={{ lineHeight: 1, paddingTop: 2 }}>{initials}</span>
      }
    </div>
  );
};

export const Stars = ({ rating, size = 13 }) => (
  <span style={{ display: "inline-flex", alignItems: "center", gap: 1 }}>
    {[1,2,3,4,5].map(n => (
      <span key={n} style={{ width: size, height: size, color: n <= Math.round(rating) ? "#f5a623" : "#ddd" }}>{IC.star}</span>
    ))}
    <span style={{ fontSize: size - 1, color: "var(--muted)", marginLeft: 4, fontWeight: 600 }}>{rating ? rating.toFixed(1) : "—"}</span>
  </span>
);

export const Pill = ({ children, color = "var(--accent)", bg }) => (
  <span style={{ display: "inline-flex", alignItems: "center", padding: "3px 10px", borderRadius: 99, background: bg || `${color}18`, color, fontSize: 11, fontWeight: 700, fontFamily: "Syne", letterSpacing: "0.04em", textTransform: "uppercase", border: `1px solid ${color}30` }}>{children}</span>
);

export const Field = ({ label, icon, ...props }) => (
  <div style={{ display: "flex", flexDirection: "column", gap: 5, minWidth: 0 }}>
    {label && <label style={{ fontSize: 11, fontWeight: 700, color: "var(--muted)", fontFamily: "Syne", letterSpacing: "0.07em", textTransform: "uppercase" }}>{label}</label>}
    <div style={{ position: "relative", minWidth: 0 }}>
      {icon && <span style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", width: 16, height: 16, color: "var(--muted)", pointerEvents: "none" }}>{icon}</span>}
      <input style={{ display: "block", width: "100%", minWidth: 0, padding: icon ? "12px 14px 12px 38px" : "12px 14px", borderRadius: 12, border: "1.5px solid var(--border)", background: "var(--card)", fontSize: 16, color: "var(--ink)", transition: "border-color .15s" }} {...props}/>
    </div>
  </div>
);

export const SelectField = ({ label, value, onChange, children }) => (
  <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
    {label && <label style={{ fontSize: 11, fontWeight: 700, color: "var(--muted)", fontFamily: "Syne", letterSpacing: "0.07em", textTransform: "uppercase" }}>{label}</label>}
    <div style={{ position: "relative" }}>
      <select value={value} onChange={onChange} style={{ width: "100%", padding: "12px 36px 12px 14px", borderRadius: 12, border: "1.5px solid var(--border)", background: "var(--card)", fontSize: 14, color: value ? "var(--ink)" : "var(--muted)", transition: "border-color .15s" }}>
        {children}
      </select>
      <span style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", pointerEvents: "none", color: "var(--muted)", fontSize: 9 }}>▼</span>
    </div>
  </div>
);

export const Btn = ({ children, variant = "primary", onClick, disabled, small, style: s }) => {
  const variants = {
    primary: { background: "#0f0e13",                                 color: "#fff", boxShadow: "0 4px 14px rgba(15,14,19,.22)" },
    accent:  { background: "linear-gradient(135deg,#2b5be0,#5a80f0)", color: "#fff", boxShadow: "0 4px 14px rgba(43,91,224,.30)" },
    blue:    { background: "linear-gradient(135deg,#1a3db5,#5a80f0)", color: "#fff", boxShadow: "0 4px 14px rgba(43,91,224,.28)" },
    success: { background: "linear-gradient(135deg,#0f9e68,#1ec885)", color: "#fff", boxShadow: "0 4px 14px rgba(15,158,104,.28)" },
    ghost:   { background: "transparent", color: "var(--ink)",        border: "1.5px solid var(--border)" },
    danger:  { background: "var(--error-bg)", color: "#c0392b",        border: "1.5px solid var(--error-border)" },
  };
  return (
    <button className="btn-press" onClick={onClick} disabled={disabled} style={{ padding: small ? "9px 16px" : "13px 20px", borderRadius: small ? 10 : 14, fontFamily: "Syne", fontWeight: 700, fontSize: small ? 12 : 14, letterSpacing: "0.02em", display: "flex", alignItems: "center", justifyContent: "center", gap: 6, width: "100%", transition: "all .15s", ...variants[variant], opacity: disabled ? 0.45 : 1, ...s }}>
      {children}
    </button>
  );
};

// ── Loading ───────────────────────────────────────────────────────────────────
export const LoadingScreen = () => (
  <div style={{ height: "100dvh", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--paper)" }}>
    <div className="apulse" style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <span style={{ width: 10, height: 10, borderRadius: "50%", background: "var(--accent)", display: "inline-block" }}/>
        <span style={{ fontFamily: "Syne", fontWeight: 800, fontSize: 36, color: "var(--accent)", lineHeight: 1 }}>iGo</span>
      </div>
      <span style={{ fontFamily: "Syne", fontWeight: 600, fontSize: 11, letterSpacing: "0.18em", color: "var(--muted)", textTransform: "uppercase" }}>Share rides, save money, connect.</span>
    </div>
  </div>
);

// ── Place Autocomplete (OpenStreetMap Nominatim) ──────────────────────────────
export const PlaceAutocomplete = ({ label, placeholder, value, onChange, onCoords }) => {
  const [query, setQuery]     = useState(value || "");
  const [results, setResults] = useState([]);
  const [open, setOpen]       = useState(false);
  const [loading, setLoading] = useState(false);
  const debounceRef           = useRef(null);
  const containerRef          = useRef(null);

  useEffect(() => { setQuery(value || ""); }, [value]);

  useEffect(() => {
    const handler = e => {
      if (containerRef.current && !containerRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const fetchPlaces = q => {
    if (!q || q.length < 2) { setResults([]); setOpen(false); return; }
    setLoading(true);
    const url = `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(q)}&countrycodes=cy&format=json&limit=7&addressdetails=1`;
    window.fetch(url, { headers: { "Accept-Language": "en" } })
      .then(r => r.json())
      .then(data => {
        const items = data.map(d => {
          const a = d.address || {};
          const place = a.village || a.town || a.city || a.hamlet || a.suburb || a.county || d.display_name.split(",")[0];
          const district = a.state_district || a.county || a.state || "";
          return { id: d.place_id, label: place, full: district ? `${place}, ${district}` : place, lat: parseFloat(d.lat), lon: parseFloat(d.lon) };
        });
        const seen = new Set();
        const unique = items.filter(i => { if (seen.has(i.label)) return false; seen.add(i.label); return true; });
        setResults(unique);
        setOpen(unique.length > 0);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  const handleInput = e => {
    const q = e.target.value;
    setQuery(q);
    onChange(q);
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => fetchPlaces(q), 320);
  };

  const select = item => {
    setQuery(item.label);
    onChange(item.label);
    if (onCoords) onCoords({ lat: item.lat, lon: item.lon });
    setResults([]);
    setOpen(false);
  };

  return (
    <div ref={containerRef} style={{ display: "flex", flexDirection: "column", gap: 5, position: "relative" }}>
      {label && <label style={{ fontSize: 11, fontWeight: 700, color: "var(--muted)", fontFamily: "Syne", letterSpacing: "0.07em", textTransform: "uppercase" }}>{label}</label>}
      <div style={{ position: "relative" }}>
        <span style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", width: 16, height: 16, color: "var(--muted)", pointerEvents: "none" }}>{IC.pin}</span>
        <input value={query} onChange={handleInput} onFocus={() => results.length > 0 && setOpen(true)}
          placeholder={placeholder} autoComplete="off"
          style={{ width: "100%", padding: "12px 14px 12px 38px", borderRadius: 12, border: "1.5px solid var(--border)", background: "var(--card)", fontSize: 14, color: "var(--ink)", transition: "border-color .15s" }}
        />
        {loading && <span style={{ position: "absolute", right: 12, top: "50%", marginTop: -7, width: 14, height: 14, border: "2px solid var(--border)", borderTopColor: "var(--accent)", borderRadius: "50%", animation: "igo-spin .7s linear infinite" }}/>}
      </div>
      {open && (
        <div style={{ position: "absolute", top: "100%", left: 0, right: 0, zIndex: 999, background: "var(--card)", borderRadius: 14, border: "1.5px solid var(--border)", boxShadow: "0 8px 32px rgba(13,13,15,.14)", overflow: "hidden", marginTop: 4 }}>
          {results.map(item => (
            <button key={item.id} onMouseDown={() => select(item)}
              style={{ display: "flex", flexDirection: "column", width: "100%", padding: "11px 16px", textAlign: "left", borderBottom: "1px solid var(--border)", transition: "background .1s" }}
              onMouseEnter={e => e.currentTarget.style.background = "var(--warm)"}
              onMouseLeave={e => e.currentTarget.style.background = "transparent"}
            >
              <span style={{ fontSize: 14, fontWeight: 600, color: "var(--ink)" }}>{item.label}</span>
              {item.full !== item.label && <span style={{ fontSize: 11, color: "var(--muted)", marginTop: 1 }}>{item.full}</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

// ── Theme Context ────────────────────────────────────────────────────────────
const ThemeCtx = createContext({ dark: false, toggle: () => {} });
export const useTheme = () => useContext(ThemeCtx);
export const ThemeProvider = ({ children }) => {
  const [dark, setDark] = useState(() => {
    try { return localStorage.getItem("igo-theme") === "dark"; } catch { return false; }
  });
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", dark ? "dark" : "");
    try { localStorage.setItem("igo-theme", dark ? "dark" : "light"); } catch {}
  }, [dark]);
  const toggle = useCallback(() => setDark(d => !d), []);
  return <ThemeCtx.Provider value={{ dark, toggle }}>{children}</ThemeCtx.Provider>;
};

export const ThemeToggle = () => {
  const { dark, toggle } = useTheme();
  return (
    <button className={`igo-theme-toggle${dark ? " dark" : ""}`} onClick={e => { e.stopPropagation(); toggle(); }}>
      <div className="igo-theme-toggle-knob"/>
    </button>
  );
};

// ── Toast System ─────────────────────────────────────────────────────────────
const ToastCtx = createContext(() => {});
export const useToast = () => useContext(ToastCtx);

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);
  const idRef = useRef(0);
  const show = useCallback((text, type = "success") => {
    const id = ++idRef.current;
    setToasts(t => [...t, { id, text, type, out: false }]);
    setTimeout(() => setToasts(t => t.map(x => x.id === id ? { ...x, out: true } : x)), 3200);
    setTimeout(() => setToasts(t => t.filter(x => x.id !== id)), 3600);
  }, []);
  return (
    <ToastCtx.Provider value={show}>
      {children}
      <div className="igo-toast-container">
        {toasts.map(t => (
          <div key={t.id} className={`igo-toast igo-toast-${t.type}${t.out ? " fade-out" : ""}`}>
            <span style={{ fontSize: 16, flexShrink: 0 }}>
              {t.type === "success" ? "✓" : t.type === "error" ? "✕" : "ℹ"}
            </span>
            <span style={{ flex: 1, fontSize: 13, fontWeight: 600 }}>{t.text}</span>
            <button onClick={() => setToasts(ts => ts.filter(x => x.id !== t.id))}
              style={{ color: "#fff", opacity: .7, width: 18, height: 18 }}>
              {IC.x}
            </button>
          </div>
        ))}
      </div>
    </ToastCtx.Provider>
  );
};

// ── Splash Screen ────────────────────────────────────────────────────────────
// Concept 3: "Question Mark Transforms" — exact replica of splash-concepts.html.
// All styles inline, all animation via direct style mutation (no CSS classes/keyframes).
// Layout: [You ][·i(hidden)][Go][?] in a centered flex row.
// At t=2300 "You" and "?" get display:none, flex re-centers to "·iGo".
export const SplashScreen = ({ onDone }) => {
  const containerRef = useRef(null);
  const youRef       = useRef(null);
  const iRef         = useRef(null);
  const qRef         = useRef(null);
  const tagRef       = useRef(null);
  const barRef       = useRef(null);
  const timers       = useRef([]);

  useEffect(() => {
    if (sessionStorage.getItem('splashPlayed')) { onDone(); return; }

    const t = (ms, fn) => { const id = setTimeout(fn, ms); timers.current.push(id); };

    // Start progress bar fill immediately
    requestAnimationFrame(() => { if (barRef.current) barRef.current.style.width = '100%'; });

    // t=1200 ms – "?" rotates 360° and shrinks to scale(0)
    t(1200, () => {
      if (!qRef.current) return;
      qRef.current.style.transform = 'rotate(360deg) scale(0)';
      qRef.current.style.opacity = '0';
    });

    // t=1800 ms – "You" slides up and fades out
    t(1800, () => {
      if (!youRef.current) return;
      youRef.current.style.transform = 'translateY(-40px)';
      youRef.current.style.opacity = '0';
    });

    // t=2300 ms – collapse "You" and "?", drop in "·i"
    t(2300, () => {
      if (youRef.current) youRef.current.style.display = 'none';
      if (qRef.current)   qRef.current.style.display = 'none';
      if (iRef.current) {
        iRef.current.style.opacity = '1';
        iRef.current.style.transform = 'translateY(0)';
      }
    });

    // t=2900 ms – tagline fades in
    t(2900, () => { if (tagRef.current) tagRef.current.style.opacity = '1'; });

    // t=3600 ms – entire splash fades out
    t(3600, () => {
      if (!containerRef.current) return;
      containerRef.current.style.opacity = '0';
      containerRef.current.style.transform = 'scale(1.1)';
    });

    // t=4200 ms – set guard + unmount
    t(4200, () => { sessionStorage.setItem('splashPlayed', '1'); onDone(); });

    return () => timers.current.forEach(clearTimeout);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div ref={containerRef} style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column',
      background: 'linear-gradient(160deg, #0f1528 0%, #1a2e6e 50%, #2b5be0 100%)',
      transition: 'opacity 0.6s ease, transform 0.6s ease',
    }}>
      <div style={{
        display: 'flex', alignItems: 'baseline', justifyContent: 'center',
        fontFamily: "'Syne', sans-serif", fontWeight: 800, fontSize: 56,
        color: '#fff', letterSpacing: -1,
      }}>
        <span ref={youRef} style={{
          display: 'inline-block',
          willChange: 'transform, opacity',
          transition: 'transform 0.5s ease, opacity 0.5s ease',
        }}>You </span>
        <span ref={iRef} style={{
          display: 'inline-block', opacity: 0, transform: 'translateY(-40px)',
          willChange: 'transform, opacity',
          transition: 'transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1), opacity 0.4s ease',
        }}>
          <span style={{
            display: 'inline-block', width: 8, height: 8,
            background: '#4a8af4', borderRadius: '50%',
            marginRight: 2, verticalAlign: 'middle',
            position: 'relative', top: -1,
          }}/>i
        </span>
        <span style={{ display: 'inline-block' }}>Go</span>
        <span ref={qRef} style={{
          display: 'inline-block',
          willChange: 'transform, opacity',
          transition: 'transform 0.6s ease, opacity 0.5s ease',
          transformOrigin: 'center center',
        }}>?</span>
      </div>
      <p ref={tagRef} style={{
        fontFamily: "'Syne', sans-serif", fontWeight: 600, fontSize: 12,
        color: 'rgba(255,255,255,0.5)', letterSpacing: 0.3,
        marginTop: 12, opacity: 0,
        transition: 'opacity 0.6s ease',
      }}>Share rides, save money, connect.</p>
      <div style={{
        position: 'absolute', bottom: 48, left: '50%', transform: 'translateX(-50%)',
        width: '60%', height: 2, borderRadius: 2,
        background: 'rgba(255,255,255,0.1)', overflow: 'hidden',
      }}>
        <div ref={barRef} style={{
          height: '100%', width: '0%', borderRadius: 2,
          background: 'rgba(255,255,255,0.6)',
          transition: 'width 3.2s ease-in-out',
        }}/>
      </div>
    </div>
  );
};

// ── Skeleton Trip Card ───────────────────────────────────────────────────────
export const TripSkeleton = ({ count = 3 }) => (
  <>
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="igo-skeleton">
        <div className="skel-line w60 thick"/>
        <div className="skel-line w80"/>
        <div className="skel-line w40"/>
        <div className="skel-row">
          <div className="skel-circle"/>
          <div style={{ flex: 1 }}>
            <div className="skel-line w60" style={{ marginBottom: 6 }}/>
            <div className="skel-line w40" style={{ marginBottom: 0 }}/>
          </div>
        </div>
      </div>
    ))}
  </>
);

// ── Empty State ──────────────────────────────────────────────────────────────
export const EmptyState = ({ icon, title, description }) => (
  <div className="igo-empty">
    <div className="igo-empty-illust">
      <span style={{ width: 48, height: 48, color: "var(--accent)", opacity: .6 }}>{icon || IC.pin}</span>
    </div>
    <div style={{ fontFamily: "Syne", fontWeight: 700, fontSize: 17, color: "var(--ink)", marginBottom: 6 }}>{title}</div>
    <div style={{ fontSize: 13, color: "var(--muted)", lineHeight: 1.5 }}>{description}</div>
  </div>
);

// ── Verified Badge ───────────────────────────────────────────────────────────
export const VerifiedBadge = ({ size = 14 }) => (
  <span className="igo-verified" style={{ width: size, height: size }}>
    <svg width={size * 0.57} height={size * 0.57} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round"><path d="M20 6L9 17l-5-5"/></svg>
  </span>
);
